module.exports = __webpack_public_path__ + "img/icon3.2df56969.png";